"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Font = void 0;

var _styledComponents = require("styled-components");

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    text-decoration: underline;\n    ", "\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    font-style: italic;\n    ", "\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    font-family: var(--f-article), serif;\n    ", "\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 300;\n    font-variant: all-small-caps oldstyle-nums;\n    letter-spacing: 1px;\n    ", "\n    ", "\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 400;\n    ", "\n    ", "\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 600;\n    letter-spacing: -0.25px;\n    ", "\n    ", "\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 700;\n    letter-spacing: -0.28px;\n    ", "\n    ", "\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 700;\n    letter-spacing: -0.35px;\n    ", "\n    ", "\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 900;\n    letter-spacing: -0.8px;\n    ", "\n    ", "\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    font-size: 0.75rem;\n    font-weight: 600;\n    font-variant: all-small-caps oldstyle-nums;\n    line-height: 1;\n    letter-spacing: 1px;\n    ", "\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 700;\n    ", "\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    text-decoration: underline;\n    ", "\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-style: italic;\n    ", "\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 400;\n    letter-spacing: 0.5px;\n    ", "\n    ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin: 0;\n    font-family: var(--f-code), monospace;\n    font-weight: 400;\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-family: var(--f-body), sans-serif;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "rem;\n  line-height: 1.375;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var fontSize = function fontSize(_ref) {
  var fontSize = _ref.fontSize;
  return (0, _styledComponents.css)(_templateObject(), fontSize / 16);
};

var sans = function sans() {
  return (0, _styledComponents.css)(_templateObject2());
};

var Font = {
  codeRegular: function codeRegular() {
    return (0, _styledComponents.css)(_templateObject3(), fontSize({
      fontSize: 13
    }));
  },
  bodySmall: function bodySmall() {
    return (0, _styledComponents.css)(_templateObject4(), fontSize({
      fontSize: 12
    }), sans());
  },
  bodyRegular: function bodyRegular() {
    return (0, _styledComponents.css)(_templateObject5(), fontSize({
      fontSize: 16
    }), sans());
  },
  bodyItalic: function bodyItalic() {
    return (0, _styledComponents.css)(_templateObject6(), Font.bodyRegular());
  },
  bodyUnderlined: function bodyUnderlined() {
    return (0, _styledComponents.css)(_templateObject7(), Font.bodyRegular());
  },
  bodyBold: function bodyBold() {
    return (0, _styledComponents.css)(_templateObject8(), Font.bodyRegular());
  },
  caption: function caption() {
    return (0, _styledComponents.css)(_templateObject9(), sans());
  },
  h1: function h1() {
    return (0, _styledComponents.css)(_templateObject10(), fontSize({
      fontSize: 46
    }), sans());
  },
  h2: function h2() {
    return (0, _styledComponents.css)(_templateObject11(), fontSize({
      fontSize: 32
    }), sans());
  },
  h3: function h3() {
    return (0, _styledComponents.css)(_templateObject12(), fontSize({
      fontSize: 24
    }), sans());
  },
  h4: function h4() {
    return (0, _styledComponents.css)(_templateObject13(), fontSize({
      fontSize: 22
    }), sans());
  },
  h5: function h5() {
    return (0, _styledComponents.css)(_templateObject14(), fontSize({
      fontSize: 20
    }), sans());
  },
  h6: function h6() {
    return (0, _styledComponents.css)(_templateObject15(), fontSize({
      fontSize: 16
    }), sans());
  },
  articleRegular: function articleRegular() {
    return (0, _styledComponents.css)(_templateObject16(), fontSize({
      fontSize: 14
    }));
  },
  articleBold: function articleBold() {
    return (0, _styledComponents.css)(_templateObject17(), Font.articleRegular());
  },
  articleUnderlined: function articleUnderlined() {
    return (0, _styledComponents.css)(_templateObject18(), Font.articleRegular());
  }
};
exports.Font = Font;